import DataLayerHelper from "@/helpers/global/dataLayer.helper";

export class ContactFormLogic {
  init() {
    //Contact form interaction functions
    //Display various screens based on "what are you heating type" functions.

    //heating type sections of contact form.
    //keyed object for labels and form field name.
    const heating_types = {
      'forced-air': {
        application_gas: 'Gas',
        'contact-application-flow-rate': 'Flow Rate (SCFM)',
        'contact-application-pressure': 'Pressure (PSI)',
        'contact-application-inlet-temperature': 'Inlet Temperature',
        'contact-application-exhaust-temperature': 'Exhaust Temperature',
        'contact-application-available-power': 'Available Supply Voltage',
        'cf-forced-heater-qty': 'Heater Qty',
        'contact-application-thermocouple': 'Thermocouple Needed',
        'contact-application-cpanel': 'Control Panel Needed',
      },
      'still-air': {
        'cf-enclosure_position': 'Enclosure Position',
        'cf-enclosure_surrounded': 'Is another enclosure adjacent to this enclosure',
        'cf-enclosure_material': 'Material',
        'cf-enclosure_location': 'Enclosure Location',
        'cf-enclosure_dimensions_height': 'Height',
        'cf-enclosure_dimensions_width': 'Width',
        'cf-enclosure_dimensions_depth': 'Depth',
        'cf-enclosure_desired_interior_temp': 'Enclosure Interior Temp',
        'cf-enclosure_lowest_ambient_temp': 'Lowest Ambient (outside) Temp',
        'cf-enclosure_other_heat': 'Heating Power (PV)',
        'cf-enclosure_calculated-heating-power': 'Calculated Heating Power',
        'cf-enclosure_calculated-area': 'Area',
        'cf-enclosure_calculated-k': 'K',
        'cf-enclosure-heater-qty': 'Heater Qty',
      },
      surface: {
        'contact-application-surface-volts': 'Volts',
        'contact-application-surface-watts': 'Wats',
        'contact-application-surface-shape': 'Shape',
        'contact-application-surface-length': 'Length',
        'contact-application-surface-width': 'Width',
        'contact-application-surface-diameter': 'Diameter',
        'contact-application-surface-description': 'Custom Shape Description',
        'contact-application-surface-annual-usage': 'Annual Usage',
        'contact-application-attachment': 'Attachment Method',
        'contact-application-surface-temp-sensor': 'Temperature Sensor',
        'contact-application-surface-thermostat': 'Thermostat',
        'contact-application-surface-thermostat-location': 'Thermostat Location',
        'contact-application-connectors': 'Connector(s) Needed',
        'contact-application-lead-time': 'Lead Time',
        'contact-application-surface-lead-type': 'Lead Type',
        'contact-application-lead-length': 'Lead Wire Length',
        'contact-application-lead-length-other': 'Lead Wire Length',
        'contact-application-listing-requirements': 'Listing Requirements',
        'cf-surface-heater-qty': 'Heater Qty',
        'contact-application-surface_temp': 'Desired Surface Temp',
      },
    };

    let heating_type_selection = '';
    let heating_type = '';

    jQuery(document).ready(function () {
      function qs(key) {
        key = key.replace(/[*+?^$.\[\]{}()|\\\/]/g, '\\$&'); // escape RegEx control chars
        const match = location.search.match(new RegExp('[?&]' + key + '=([^&]+)(&|$)'));
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
      }

      //shows the modal contact form popup upon page load if query string is present.
      if (location.search && qs('show-quote') == '1') {
        $('#contact-form-modal').modal('show');
      }

      //allows for the form to be preset for a heating type based on query string.
      if (qs('heating-type') != null) {
        $('.general-type-button.heat-project').addClass('selected');
        $('#contact-form-reason').hide();
        $('.entire-contact-form.hidden').removeClass('hidden');
        $('.what-are-you-heating').slideDown();
        $('.what-are-you-heating-header').show();
        $('.heating-type-button.' + qs('heating-type')).addClass('selected');
        $('.heating-type-' + qs('heating-type')).show();
        //hide other fields until user click the heating type
        //$('.hide-init').hide();
      }

      function scrollUp() {
        if ($('#contact-form-modal').length) {
          $('#contact-form-modal').animate({ scrollTop: $('#contact_form').offset().top - 125 });
        } else {
          $('html, body').animate({ scrollTop: $('#contact_form').offset().top - 125 });
        }
      }

      //removes alot of the unnecessary parts of form when requesting a temperature card.
      $('a.request-temperature-card').on('click', function (event) {
        $('#contact-form-reason').hide();
        $('.what-are-you-heating').hide();
        $('#fieldset-contact-information').show();
        $('.products-of-interest').hide();
        $('.hide-init').show();
        $('label[for="contact-more-info"]').hide();
        $($('#more-info-section').children()[1]).hide();
        $('#contact-form-heating-needs legend h2').first().text('Request a Temperature Reference Card');
        $('#contact-more-info').val('I would like a temperature reference card.');
        heating_type = 'not needed';
        heating_type_selection = 'not needed';
        $('.products-of-interest').hide();
      });

      //abbreviated quote form for medical industry.
      $('a.industry.quote-link').on('click', function (event) {
        $('.entire-contact-form ').addClass('minimal');
        $('#contact-form-reason').hide();
        $('.what-are-you-heating').hide();
        $('#fieldset-contact-information').show();
        $('.products-of-interest').hide();
        $('.hide-init').show();
        $('label[for="contact-more-info"]').hide();
        //$($('#more-info-section').children()[1]).hide();
        $('#contact-form-heating-needs legend h2').first().text('Please describe your heating requirements.');
        //$('#contact-more-info').val("I would like a temperature reference card.");
        heating_type = 'not needed';
        heating_type_selection = 'not needed';
        $('.products-of-interest').hide();
      });

      $('#contact-form-reason .general-type-button').on('click', function (event) {
        $('.entire-contact-form.hidden').removeClass('hidden');
        $('#contact-form-reason .general-type-button .link-button').find('span').removeClass('glyphicon-glyphicon-ok');
        $('#contact-form-reason .general-type-button').removeClass('selected');
        $(this).addClass('selected');
        $(this).find('.link-button span').addClass('glyphicon-glyphicon-ok');
        $('#more-info-section').slideDown();
        $('#contact-form-reason h3').removeClass('error');
        $('.heating-needs-header').show();
        if ($(this).hasClass('heat-project')) {
          if ($('#contact-form-modal').length < 1) {
            $('.what-are-you-heating').slideDown();
            $('.what-are-you-heating-header').show();
            //hide other fields until user click the heating type
            $('.hide-init').hide();
            $('#more-info-section .flip-label label').text('A Description of Your Application');
          }
          $('#contact-form-heating-needs legend h2').first().text('What are you heating?');
        } else {
          $('#contact-form-heating-needs legend h2').first().text('How Can We Help?');
          $('.what-are-you-heating').slideUp();
          $('.products-of-interest').hide();
          $('#more-info-section .flip-label label').text('More Info');
        }
      });

      //user selected the heating type button, so we can show the other fields.
      $('.heating-type-button').on('click', function (event) {
        $('.hide-init').show();
      });

      //treat optin check boxes as radio buttons
      //each requires their own name in the form.
      $('#LEADCF106').on('change', function (t) {
        //$('#Email_Opt_Out')[0].checked = !$('#LEADCF106')[0].checked;
      });
      $('#Email_Opt_Out').on('change', function (t) {
        //$('#LEADCF106')[0].checked = !$('#Email_Opt_Out')[0].checked;
      });

      $('#contact_form')
        .validator()
        .on('submit', function (e) {
          if ($('#contact-form-in-get-a-quote-modal').length < 1) {
            if ($('#contact-form-reason .general-type-button.selected').length == 0) {
              e.preventDefault();

              $('#form_error_container').html(
                '<div class="alert alert-danger">' +
                  '	<a href="#" class="close" data-dismiss="alert">&times;</a>' +
                  '	<strong>Error!</strong> Please select the where to direct your inquiry.' +
                  '</div>'
              );
              $('#contact-form-reason h3').addClass('error');
              return false;
            } else if (
              $('.general-type-button.heat-project.selected').length > 0 &&
              $('.what-are-you-heating .heating-type-button.selected').length == 0
            ) {
              e.preventDefault();
              scrollUp();
              $('#form_error_container').html(
                '<div class="alert alert-danger">' +
                  '	<a href="#" class="close" data-dismiss="alert">&times;</a>' +
                  '	<strong>Error!</strong> Please select the type of heating project.' +
                  '</div>'
              );
              $('.what-are-you-heating h3').addClass('error');
              return false;
            }
          }
          if (!$('#LEADCF106').prop('checked')) {
            e.preventDefault();
            scrollUp();
            $('#form_error_container').html(
              '<div class="alert alert-danger">' +
                '	<a href="#" class="close" data-dismiss="alert">&times;</a>' +
                '	<strong>Error!</strong> Please acknowledge our GDPR statement.' +
                '</div>'
            );
            $('.what-are-you-heating h3').addClass('error');
            return false;
          }
          return true;
        });

      $('#contact-form-modal').on('shown.bs.modal', function (ele) {
        //it's a modal - they want a quote so don't show the how can we direct your inquire seciton.

        if (heating_type != 'not needed') {
          $('.what-are-you-heating').show();
        }
        $('#more-info-section').show();
        heating_type = 'not needed';

        if (typeof $(ele.relatedTarget).data('preset') != 'undefined' && $(ele.relatedTarget).data('preset') != '') {
          heating_type = $(ele.relatedTarget).data('preset');
          $('.row.heating-type-options').hide();
          $('.heating-type-button').removeClass('selected');
          $('.heating-type-' + heating_type).show();
          $('.heating-type-button.' + heating_type).addClass('selected');
        }

        //populate the enclosure heaters form section with cookie data from calculator.
        const enclosure_heater_calc_data = $.cookie('enclosure_heater_calc_data');
        if (typeof enclosure_heater_calc_data != 'undefined') {
          //load and parse the data from the delicious cookie...
          const data = JSON.parse(enclosure_heater_calc_data);
          $('.heating-type-options.heating-type-still-air label').addClass('focused');
          $(".heating-type-options.heating-type-still-air input[name=cf-enclosure_position][value='" + data.enclosure_position + "']").prop(
            'checked',
            true
          );
          $(".heating-type-options.heating-type-still-air input[name=cf-enclosure_surrounded][value='" + data.enclosure_surrounded + "']").prop(
            'checked',
            true
          );
          $(".heating-type-options.heating-type-still-air input[name=cf-enclosure_material][value='" + data.enclosure_material + "']").prop(
            'checked',
            true
          );
          $(".heating-type-options.heating-type-still-air input[name=cf-enclosure_location][value='" + data.enclosure_location + "']").prop(
            'checked',
            true
          );
          $('.heating-type-options.heating-type-still-air #cf-enclosure_dimensions_height').val(data.height.substr(0, data.height.length - 2));
          $('.heating-type-options.heating-type-still-air #cf-enclosure_dimensions_height_unit').val('feet');
          $('.heating-type-options.heating-type-still-air #cf-enclosure_dimensions_height_unit').next().find('.btn-text').text('feet');
          $('.heating-type-options.heating-type-still-air #cf-enclosure_dimensions_width').val(data.width.substr(0, data.width.length - 2));
          $('.heating-type-options.heating-type-still-air #cf-enclosure_dimensions_width_unit').val('feet');
          $('.heating-type-options.heating-type-still-air #cf-enclosure_dimensions_width_unit').next().find('.btn-text').text('feet');
          $('.heating-type-options.heating-type-still-air #cf-enclosure_dimensions_depth').val(data.depth.substr(0, data.depth.length - 2));
          $('.heating-type-options.heating-type-still-air #cf-enclosure_dimensions_depth_unit').val('feet');
          $('.heating-type-options.heating-type-still-air #cf-enclosure_dimensions_depth_unit').next().find('.btn-text').text('feet');
          $('.heating-type-options.heating-type-still-air #cf-enclosure_desired_interior_temp').val(
            data.enclosure_desired_interior_temp.substr(0, data.enclosure_desired_interior_temp.length - 1)
          );
          $('.heating-type-options.heating-type-still-air #cf-enclosure_desired_interior_temp_unit')
            .next()
            .find('.btn-text')
            .html('&deg;' + data.enclosure_desired_interior_temp.substr(data.enclosure_desired_interior_temp.length - 1));
          $('.heating-type-options.heating-type-still-air #cf-enclosure_lowest_ambient_temp').val(
            data.enclosure_lowest_ambient_temp.substr(0, data.enclosure_lowest_ambient_temp.length - 1)
          );
          $('.heating-type-options.heating-type-still-air #cf-enclosure_lowest_ambient_temp_unit')
            .next()
            .find('.btn-text')
            .html('&deg;' + data.enclosure_lowest_ambient_temp.substr(data.enclosure_lowest_ambient_temp.length - 1));
          $('.heating-type-options.heating-type-still-air #cf-enclosure_other_heat').val(data.enclosure_other_heat);
          $('.heating-type-options.heating-type-still-air #cf-enclosure_calculated-heating-power').val(data.pretty_heating_power);
          $('.heating-type-options.heating-type-still-air #cf-enclosure_calculated-area').val(data.area);
          $('.heating-type-options.heating-type-still-air #cf-enclosure_calculated-k').val(data.k);
        }
        DataLayerHelper.send('modal_contact_form_view', "Contact form",  'Form visible','Modal contact form',1);


        $('#more-info-section .flip-label label').text('A Description of Your Application');

        //opens the collapsable product panels for the ones that are preselected
        $('.checkbox input:checkbox:checked').each(function () {
          const parent = $('#' + $(this).data('parent'));
          parent.collapse('toggle');
        });
      });

      //toggles display of the various heating types
      //forced air
      //still air - enclosures
      //surface - flexible heaters
      $('#contact_form .heating-type-button').on('click', function (event) {
        event.preventDefault();
        const button = $(event.currentTarget);
        $('#contact_form .heating-type-button').removeClass('selected');
        $(this).addClass('selected');
        for (const type in heating_types) {
          if (type != button.data('type')) $('.heating-type-' + type).hide();
        }
        $('.heating-type-' + button.data('type')).slideDown();
        $('.what-are-you-heating h3').removeClass('error');
        heating_type_selection = button.data('type');
      });

      $('#contact-application-lead-length').on('change', function () {
        if ($(this).val() == 'Other') {
          $('.lead-length-custom').slideDown();
        } else {
          $('.lead-length-custom').slideUp();
        }
      });

      //if they choose a thermosat under flexible heaters it should ask what type
      //also the checkbox should automatically checked if they select high limit is selected
      $('#contact-application-surface-thermostat').on('change', function () {
        if ($(this).val() != 'No Thermostat is Needed' && $(this).val() != 'Opening temperature, standard tolerance') {
          if ($(this).val() == 'High Limit Thermostat') {
            $('#contact-application-surface-thermostat-location-external').parent().hide();
            $('#contact-application-surface-thermostat-location-internal').prop('checked', true);
          } else {
            $('#contact-application-surface-thermostat-location-external').parent().show();
          }
          $('#cf-surface-thermostat-location').slideDown();
        } else {
          $('#contact-application-surface-thermostat-location-internal').prop('checked', false);
          $('#contact-application-surface-thermostat-location-external').prop('checked', false);
          $('#cf-surface-thermostat-location').slideUp();
        }
      });
      $('#cf-surface-thermostat-location').hide();

      //add the replacement part number or description to the LEADCF1 array of checkboxes.
      $('#contact-replacement-heater').on('change', function (event) {
        $('#contact-replacement-heater-part').val($('#contact-replacement-heater').val());
      });
      //add the replacement part number or description to the LEADCF1 array of checkboxes.
      $('#other-engineering-help').on('change', function (event) {
        $('#other-engineering-help-description').val($('#other-engineering-help').val());
      });
      //add the replacement part number or description to the LEADCF1 array of checkboxes.
      $('#other-enclosure-heater').on('change', function (event) {
        $('#other-enclosure-heater-description').val($('#other-enclosure-heater').val());
      });

      //show checkboxes for the options available for the product if available.
      $('.contact-form .products .checkbox input[type="checkbox"]').change(function (event) {
        if (this.checked) {
          $(this).parent().nextAll().slideDown();
        } else {
          $(this)
            .parent()
            .nextAll()
            .each(function () {
              $(this).find('input[type="checkbox"]').prop('checked', false);
            });
          $(this).parent().nextAll().slideUp();
        }
      });

      function convertToInches(v, unit) {
        switch (unit) {
          case 'centimeters':
            v = v / 2.54;
            break;
          case 'feet':
            v = v * 12;
            break;
          case 'meters':
            v = v * 39.37;
            break;
        }
        return v;
      }

      function calcRectangularWattDensity() {
        if (
          $('#contact-application-surface-watts').val() > 0 &&
          $('#contact-application-surface-length').val() > 0 &&
          $('#contact-application-surface-width').val() > 0
        ) {
          const w = $('#contact-application-surface-watts').val();
          const width = convertToInches($('#contact-application-surface-width').val(), $('#contact-application-surface-width_unit').val());
          const length = convertToInches($('#contact-application-surface-length').val(), $('#contact-application-surface-length_unit').val());
          const sq = width * length;
          const density = parseFloat(w / sq).toPrecision(4);
          let warning = '';
          if (density > 30) {
            warning =
              "<span style='color:red;'><strong>Warning!</strong> This watt density is beyond the capabilities of silicone rubber heaters. Only polyimide heaters will be suitable.</span>";
          }
          if (density > 50) {
            warning =
              "<span style='color:red;'><strong>Warning!</strong> This watt density is beyond the capabilities of polyimide and silicone rubber heaters!</span>";
          }
          $('.calc-watt-density.rectangle').html('<h4>Calculated Watt Density: <strong>' + density + ' W/sq.in.</strong> ' + warning + '</h4>');
        }
      }

      function calcCircularWattDensity() {
        if ($('#contact-application-surface-watts').val() > 0 && $('#contact-application-surface-diameter').val() > 0) {
          const w = $('#contact-application-surface-watts').val();
          const d = convertToInches($('#contact-application-surface-diameter').val(), $('#contact-application-surface-diameter_unit').val());
          const sq = Math.PI * ((d / 2) * (d / 2));
          const density = parseFloat(w / sq).toPrecision(4);
          let warning = '';
          if (density > 30) {
            warning =
              "<span style='color:red;'><strong>Warning!</strong> This watt density is beyond the capabilities of silicone rubber heaters. Only polyimide heaters will be suitable.</span>";
          }
          if (density > 50) {
            warning =
              "<span style='color:red;'><strong>Warning!</strong> This watt density is beyond the capabilities of polyimide and silicone rubber heaters!</span>";
          }
          $('.calc-watt-density.circle').html('<h4>Calculated Watt Density: <strong>' + density + ' W/sq.in.</strong> ' + warning + '</h4>');
        }
      }

      $('.watt-density-rect-param, #contact-application-surface-width_unit, #contact-application-surface-length_unit').on('change', function (event) {
        //calculate watt density for rectangles
        calcRectangularWattDensity();
      });

      $('.watt-density-circ-param, #contact-application-surface-diameter_unit').on('change', function (event) {
        //calculate watt density for rectangles
        calcCircularWattDensity();
      });

      //surface heater sections of contact form
      const surface_shapes = ['Rectangular', 'Circular', 'Custom'];

      //toggles the dimensions for the shape type
      $('#contact_form .surface-shape-radio').on('click', function (event) {
        const shape = $('input[name="contact-application-surface-shape"]:checked').val();
        surface_shapes.forEach(function (i) {
          if (i != shape) $('.surface-shape-' + i).hide();
        });
        $('.surface-shape-' + shape).slideDown('fast');
      });

      $('.form-control').on('focus', function () {
        $(this).closest('.form-group').find('label').addClass('focused');
      });

      $('.form-control').on('blur', function () {
        if ($(this).val() === '') {
          $(this).closest('.form-group').find('label').removeClass('focused');
        }
      });
    });

    //compiles the readable text to include with the contact form.
    function processHeatingTypeParams(txt, event) {
      //event.preventDefault();

      if (typeof txt == undefined) {
        txt = '';
      }
      if (typeof event == undefined) {
        event = '';
      }
      let heating_needs = '';
      const compiled = [];

      //for(var key in heating_types){
      const key = heating_type_selection;
      compiled[key] = '';
      for (const field in heating_types[key]) {
        if (typeof $('input[name="' + field + '"][type="checkbox"]', '#contact_form').val() == 'string') {
          var value = $('input[name="' + field + '"]:checked', '#contact_form').val();
          if (typeof value != 'undefined' && value != '') {
            compiled[key] = compiled[key] + heating_types[key][field] + ': ' + value;
          }
        } else if (typeof $('input[name="' + field + '"][type="radio"]', '#contact_form').val() == 'string') {
          var value = $('input[name="' + field + '"]:checked', '#contact_form').val();
          if (typeof value != 'undefined' && value != '') {
            compiled[key] = compiled[key] + heating_types[key][field] + ': ' + value;
          }
        } else {
          var value = $('#' + field).val();
          if (typeof value != 'undefined' && value != '') {
            compiled[key] = compiled[key] + heating_types[key][field] + ': ' + value;
          }
        }
        const unit = $('#' + field + '_unit').val();
        if (typeof value != 'undefined' && value != '' && typeof unit != 'undefined' && unit != '') {
          compiled[key] = compiled[key] + ' ' + unit;
        }
        if (typeof value != 'undefined' && value != '' && compiled[key] != '') {
          compiled[key] = compiled[key] + '\n';
        }
      }
      //}

      if (typeof compiled['forced-air'] != 'undefined' && compiled['forced-air'] != '') {
        heating_needs += '\n\n----User Submitted Forced Air Details----\n';
        heating_needs += compiled['forced-air'];
      }
      if (typeof compiled['still-air'] != 'undefined' && compiled['still-air'] != '') {
        heating_needs += '\n\n----User Submitted Still Air Details----\n';
        heating_needs += compiled['still-air'];
      }
      if (typeof compiled['surface'] != 'undefined' && compiled['surface'] != '') {
        heating_needs += '\n\n----User Submitted Surface Details----\n';
        heating_needs += compiled['surface'];
      }

      $('#contact-more-info').val(txt + heating_needs);
    }

    window.isContactFormLoaded = function () {
      // Contact form logic is loaded
    };
  }
}
